import React, {
  RefObject,
  useEffect,
} from 'react';
import {
  settingsEventChannel,
} from 'pages/Dashboard/services/eventChannels';
import Table from 'core/components/VirtualTable';
import {
  AppointmentTypeSettingDTO,
} from 'dtos/appointmentTypeSettingDTO';
import {
  useTableReset,
} from 'core/hooks';
import {
  VirtualTableInstance,
} from 'core/components/VirtualTable/types';
import {
  getAppointmentTypeSettings,
} from 'views/EMR/Settings/transport';
import {
  AppointmentTypeSettings,
} from 'views/EMR/Settings/Appointments/types';
import appointmentTypeColumns from 'views/EMR/Settings/Appointments/columns';

export default function AppointmentTypeList() {
  const { tableInstanceRef } = useTableReset();

  const onAppointmentTypeDialog = (data?: AppointmentTypeSettingDTO) => {
    settingsEventChannel.emit('onCreateAppointmentType', { data });
  };

  useEffect(() => {
    const unsubscribe = settingsEventChannel.on('onAppointmentTypesChange', () => {
      tableInstanceRef?.current?.refetch?.();
    });
    return () => { unsubscribe(); };
  }, []);

  return (
    <div className="h-full w-full flex flex-col gap-4">
      <div className=" relative flex flex-col flex-1 overflow-y-hidden">
        <div className="h-full w-full">
          <Table<AppointmentTypeSettings>
            instanceRef={tableInstanceRef as RefObject<VirtualTableInstance>}
            getData={getAppointmentTypeSettings}
            getRowId={(row) => row?.appointmentTypeSettingId}
            columns={appointmentTypeColumns}
            emptySlot="No Appointment Types Found"
            classes={{
              header: 'px-4',
              scrollContainer: 'justify-center items-center mb-7',
              outerRow: '!w-[calc(100%-16px)] left-4',
              row: '!items-start py-1',
            }}
            onRowClick={(table, row) => {
              onAppointmentTypeDialog(row?.original);
            }}
          />
        </div>
      </div>
    </div>
  );
}
